import React from "react";
import { TELEGRAM_KANAL, WHATSAPP_KANAL, INSTAGRAM_HESABI } from "../consts/Kanallar";

const dugme = (renk) => ({
    display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '16px',
    backgroundColor: renk, color: '#fff', fontSize: '13px', fontWeight: 600, textDecoration: 'none',
});

/**
 * İndirim detay sayfasında Telegram / WhatsApp kanalına davet. Kullanıcı bir indirim linkinden geldiği için takipçi
 * kazanmanın en iyi yeri; indirim sona erdiyse (`vurgulu`) "kaçırma" mesajıyla öne çıkar.
 */
export default function TakipEt({ vurgulu }) {
    return (
        <div style={{
            marginTop: '14px', padding: vurgulu ? '10px 12px' : 0, borderRadius: '8px',
            backgroundColor: vurgulu ? '#fff8e1' : 'transparent', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px'
        }}>
            <span style={{ fontSize: '13px', color: '#364354', fontWeight: vurgulu ? 600 : 400 }}>
                {vurgulu ? 'Bir dahakini kaçırma, fırsatlar anında gelsin:' : 'Fırsatları anında takip et:'}
            </span>
            <a href={TELEGRAM_KANAL} target="_blank" rel="noopener noreferrer" style={dugme('#229ED9')}>Telegram</a>
            <a href={INSTAGRAM_HESABI} target="_blank" rel="noopener noreferrer" style={dugme('#DB2777')}>Instagram</a>
            <a href={WHATSAPP_KANAL} target="_blank" rel="noopener noreferrer" style={dugme('#25D366')}>WhatsApp</a>
        </div>
    );
}
